import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import BarChart from './BarChart'
import {useAuth} from '../../../auth'
import {getFileTypes} from '../../core/_requests'
import Skeleton from 'react-loading-skeleton'

interface CountFileTypeProps {
  heading: string
}

const CountFileType: React.FC<CountFileTypeProps> = ({heading}) => {
  const {formatMessage} = useIntl()
  const {companyId} = useAuth()
  const [loading, setLoading] = useState(false)
  const [fileTypesData, setFileTypesData] = useState()
  const handleFileTypes = async () => {
    if (!companyId) return
    try {
      setLoading(true)
      const {
        data: {success, data, errors},
      } = await getFileTypes(companyId)
      if (success) {
        setFileTypesData(data)
      } else {
        console.error(errors)
      }
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    handleFileTypes()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      <div className='bg-white rounded-2 p-4'>
        <div className='px-4 pb-0 d-flex justify-content-between'>
          <div className='d-flex align-items-center gap-1 pt-2'>
            <h4 className='m-0 font-size-14 text-muted fw-normal'>
              {formatMessage({id: heading})}
            </h4>
          </div>
        </div>
        {loading ? (
          <Skeleton
            height={300}
            baseColor='var(--kt-skeleton-bg-color)'
            highlightColor='var(--kt-skeleton-highlight-bg-color)'
          />
        ) : (
          <BarChart fileTypesData={fileTypesData} />
        )}
      </div>
    </>
  )
}

export default CountFileType
